/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native-unistyles';
import { pd } from '@airasia-rn/ui';
import { getColor } from '@airasia-phoenix/react-native/utils/utils';

export const styles = StyleSheet.create((_, rt) => ({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-around',
    backgroundColor: getColor(pd.sys.colour.container_none),
    borderTopWidth: 1,
    borderTopColor: getColor(pd.sys.colour.outline_low),
    paddingTop: 8,
    paddingBottom: (rt.insets.bottom ?? 0) + 10,
  },
  actionItem: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    paddingVertical: 4,
  },
  iconWrapper: {
    width: 28,
    height: 28,
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
